/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShopSelectRouteImport } from './routes/shop-select'
import { Route as ShopLimitExceededRouteImport } from './routes/shop-limit-exceeded'
import { Route as NoticeRouteImport } from './routes/notice'
import { Route as NoLinkedMallRouteImport } from './routes/no-linked-mall'
import { Route as InstallNotEligibleRouteImport } from './routes/install-not-eligible'
import { Route as Cafe24ReauthRouteImport } from './routes/cafe24-reauth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as ShortCodeIndexRouteImport } from './routes/$shortCode/index'
import { Route as CampusSsoSelectRouteImport } from './routes/campus-sso/select'
import { Route as AuthSuccessRouteImport } from './routes/auth.success'
import { Route as AuthLinkRouteImport } from './routes/auth.link'
import { Route as ApplyTermsRouteImport } from './routes/apply/terms'
import { Route as ApplyPrivacyRouteImport } from './routes/apply/privacy'
import { Route as ApplyCallbackRouteImport } from './routes/apply/callback'
import { Route as AdminWhitelistRouteImport } from './routes/admin/whitelist'
import { Route as AdminOauthApproveRouteImport } from './routes/admin/oauth-approve'
import { Route as AdminNaverRequestsRouteImport } from './routes/admin/naver-requests'
import { Route as AdminMetaApprovalsRouteImport } from './routes/admin/meta-approvals'
import { Route as AdminMcpRouteImport } from './routes/admin/mcp'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminDiagnosticsRouteImport } from './routes/admin/diagnostics'
import { Route as AdminCustomersRouteImport } from './routes/admin/customers'
import { Route as DashboardTaxonomyRouteImport } from './routes/_dashboard/taxonomy'
import { Route as DashboardSeedingCampaignsRouteImport } from './routes/_dashboard/seeding-campaigns'
import { Route as DashboardProductGroupsRouteImport } from './routes/_dashboard/product-groups'
import { Route as DashboardMediaMixRouteImport } from './routes/_dashboard/media-mix'
import { Route as DashboardCapiRouteImport } from './routes/_dashboard/capi'
import { Route as DashboardAdPerformanceRouteImport } from './routes/_dashboard/ad-performance'
import { Route as ShortCodeSubmitRouteImport } from './routes/$shortCode/submit'
import { Route as ShortCodeMyApplicationRouteImport } from './routes/$shortCode/my-application'
import { Route as DashboardCatalogIndexRouteImport } from './routes/_dashboard/catalog/index'
import { Route as ApplyMallIdShopNoRouteImport } from './routes/apply/$mallId.$shopNo'
import { Route as AdminCustomersCustomerIdRouteImport } from './routes/admin/customers/$customerId'
import { Route as DashboardSetupTiktokRouteImport } from './routes/_dashboard/setup/tiktok'
import { Route as DashboardSetupScriptRouteImport } from './routes/_dashboard/setup/script'
import { Route as DashboardSetupNaverRouteImport } from './routes/_dashboard/setup/naver'
import { Route as DashboardSetupMixpanelRouteImport } from './routes/_dashboard/setup/mixpanel'
import { Route as DashboardSetupMetaCatalogRouteImport } from './routes/_dashboard/setup/meta-catalog'
import { Route as DashboardSetupMetaCapiRouteImport } from './routes/_dashboard/setup/meta-capi'
import { Route as DashboardSetupMetaAdsRouteImport } from './routes/_dashboard/setup/meta-ads'
import { Route as DashboardSetupKakaoRouteImport } from './routes/_dashboard/setup/kakao'
import { Route as DashboardSetupGoogleRouteImport } from './routes/_dashboard/setup/google'
import { Route as DashboardSeedingCampaignsNewRouteImport } from './routes/_dashboard/seeding-campaigns/new'
import { Route as DashboardSeedingCampaignsCampaignIdRouteImport } from './routes/_dashboard/seeding-campaigns/$campaignId'
import { Route as DashboardCatalogProductNoRouteImport } from './routes/_dashboard/catalog/$productNo'
import { Route as ApplyMallIdShopNoCampaignIdRouteImport } from './routes/apply/$mallId.$shopNo/$campaignId'
import { Route as DashboardSeedingCampaignsCampaignIdEditRouteImport } from './routes/_dashboard/seeding-campaigns/$campaignId.edit'
import { Route as ApplyMallIdShopNoSubmitCampaignIdRouteImport } from './routes/apply/$mallId.$shopNo/submit/$campaignId'
import { Route as ApplyMallIdShopNoMyApplicationCampaignIdRouteImport } from './routes/apply/$mallId.$shopNo/my-application/$campaignId'

const ShopSelectRoute = ShopSelectRouteImport.update({
  id: '/shop-select',
  path: '/shop-select',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopLimitExceededRoute = ShopLimitExceededRouteImport.update({
  id: '/shop-limit-exceeded',
  path: '/shop-limit-exceeded',
  getParentRoute: () => rootRouteImport,
} as any)
const NoticeRoute = NoticeRouteImport.update({
  id: '/notice',
  path: '/notice',
  getParentRoute: () => rootRouteImport,
} as any)
const NoLinkedMallRoute = NoLinkedMallRouteImport.update({
  id: '/no-linked-mall',
  path: '/no-linked-mall',
  getParentRoute: () => rootRouteImport,
} as any)
const InstallNotEligibleRoute = InstallNotEligibleRouteImport.update({
  id: '/install-not-eligible',
  path: '/install-not-eligible',
  getParentRoute: () => rootRouteImport,
} as any)
const Cafe24ReauthRoute = Cafe24ReauthRouteImport.update({
  id: '/cafe24-reauth',
  path: '/cafe24-reauth',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const ShortCodeIndexRoute = ShortCodeIndexRouteImport.update({
  id: '/$shortCode/',
  path: '/$shortCode/',
  getParentRoute: () => rootRouteImport,
} as any)
const CampusSsoSelectRoute = CampusSsoSelectRouteImport.update({
  id: '/campus-sso/select',
  path: '/campus-sso/select',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSuccessRoute = AuthSuccessRouteImport.update({
  id: '/auth/success',
  path: '/auth/success',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLinkRoute = AuthLinkRouteImport.update({
  id: '/auth/link',
  path: '/auth/link',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyTermsRoute = ApplyTermsRouteImport.update({
  id: '/apply/terms',
  path: '/apply/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyPrivacyRoute = ApplyPrivacyRouteImport.update({
  id: '/apply/privacy',
  path: '/apply/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyCallbackRoute = ApplyCallbackRouteImport.update({
  id: '/apply/callback',
  path: '/apply/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWhitelistRoute = AdminWhitelistRouteImport.update({
  id: '/whitelist',
  path: '/whitelist',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOauthApproveRoute = AdminOauthApproveRouteImport.update({
  id: '/oauth-approve',
  path: '/oauth-approve',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNaverRequestsRoute = AdminNaverRequestsRouteImport.update({
  id: '/naver-requests',
  path: '/naver-requests',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMetaApprovalsRoute = AdminMetaApprovalsRouteImport.update({
  id: '/meta-approvals',
  path: '/meta-approvals',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMcpRoute = AdminMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiagnosticsRoute = AdminDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomersRoute = AdminCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AdminRoute,
} as any)
const DashboardTaxonomyRoute = DashboardTaxonomyRouteImport.update({
  id: '/taxonomy',
  path: '/taxonomy',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSeedingCampaignsRoute =
  DashboardSeedingCampaignsRouteImport.update({
    id: '/seeding-campaigns',
    path: '/seeding-campaigns',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardProductGroupsRoute = DashboardProductGroupsRouteImport.update({
  id: '/product-groups',
  path: '/product-groups',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardMediaMixRoute = DashboardMediaMixRouteImport.update({
  id: '/media-mix',
  path: '/media-mix',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCapiRoute = DashboardCapiRouteImport.update({
  id: '/capi',
  path: '/capi',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdPerformanceRoute = DashboardAdPerformanceRouteImport.update({
  id: '/ad-performance',
  path: '/ad-performance',
  getParentRoute: () => DashboardRoute,
} as any)
const ShortCodeSubmitRoute = ShortCodeSubmitRouteImport.update({
  id: '/$shortCode/submit',
  path: '/$shortCode/submit',
  getParentRoute: () => rootRouteImport,
} as any)
const ShortCodeMyApplicationRoute = ShortCodeMyApplicationRouteImport.update({
  id: '/$shortCode/my-application',
  path: '/$shortCode/my-application',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardCatalogIndexRoute = DashboardCatalogIndexRouteImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => DashboardRoute,
} as any)
const ApplyMallIdShopNoRoute = ApplyMallIdShopNoRouteImport.update({
  id: '/apply/$mallId/$shopNo',
  path: '/apply/$mallId/$shopNo',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCustomersCustomerIdRoute =
  AdminCustomersCustomerIdRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => AdminCustomersRoute,
  } as any)
const DashboardSetupTiktokRoute = DashboardSetupTiktokRouteImport.update({
  id: '/setup/tiktok',
  path: '/setup/tiktok',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSetupScriptRoute = DashboardSetupScriptRouteImport.update({
  id: '/setup/script',
  path: '/setup/script',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSetupNaverRoute = DashboardSetupNaverRouteImport.update({
  id: '/setup/naver',
  path: '/setup/naver',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSetupMixpanelRoute = DashboardSetupMixpanelRouteImport.update({
  id: '/setup/mixpanel',
  path: '/setup/mixpanel',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSetupMetaCatalogRoute =
  DashboardSetupMetaCatalogRouteImport.update({
    id: '/setup/meta-catalog',
    path: '/setup/meta-catalog',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSetupMetaCapiRoute = DashboardSetupMetaCapiRouteImport.update({
  id: '/setup/meta-capi',
  path: '/setup/meta-capi',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSetupMetaAdsRoute = DashboardSetupMetaAdsRouteImport.update({
  id: '/setup/meta-ads',
  path: '/setup/meta-ads',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSetupKakaoRoute = DashboardSetupKakaoRouteImport.update({
  id: '/setup/kakao',
  path: '/setup/kakao',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSetupGoogleRoute = DashboardSetupGoogleRouteImport.update({
  id: '/setup/google',
  path: '/setup/google',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSeedingCampaignsNewRoute =
  DashboardSeedingCampaignsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardSeedingCampaignsRoute,
  } as any)
const DashboardSeedingCampaignsCampaignIdRoute =
  DashboardSeedingCampaignsCampaignIdRouteImport.update({
    id: '/$campaignId',
    path: '/$campaignId',
    getParentRoute: () => DashboardSeedingCampaignsRoute,
  } as any)
const DashboardCatalogProductNoRoute =
  DashboardCatalogProductNoRouteImport.update({
    id: '/catalog/$productNo',
    path: '/catalog/$productNo',
    getParentRoute: () => DashboardRoute,
  } as any)
const ApplyMallIdShopNoCampaignIdRoute =
  ApplyMallIdShopNoCampaignIdRouteImport.update({
    id: '/$campaignId',
    path: '/$campaignId',
    getParentRoute: () => ApplyMallIdShopNoRoute,
  } as any)
const DashboardSeedingCampaignsCampaignIdEditRoute =
  DashboardSeedingCampaignsCampaignIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardSeedingCampaignsCampaignIdRoute,
  } as any)
const ApplyMallIdShopNoSubmitCampaignIdRoute =
  ApplyMallIdShopNoSubmitCampaignIdRouteImport.update({
    id: '/submit/$campaignId',
    path: '/submit/$campaignId',
    getParentRoute: () => ApplyMallIdShopNoRoute,
  } as any)
const ApplyMallIdShopNoMyApplicationCampaignIdRoute =
  ApplyMallIdShopNoMyApplicationCampaignIdRouteImport.update({
    id: '/my-application/$campaignId',
    path: '/my-application/$campaignId',
    getParentRoute: () => ApplyMallIdShopNoRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/admin': typeof AdminRouteWithChildren
  '/cafe24-reauth': typeof Cafe24ReauthRoute
  '/install-not-eligible': typeof InstallNotEligibleRoute
  '/no-linked-mall': typeof NoLinkedMallRoute
  '/notice': typeof NoticeRoute
  '/shop-limit-exceeded': typeof ShopLimitExceededRoute
  '/shop-select': typeof ShopSelectRoute
  '/$shortCode/my-application': typeof ShortCodeMyApplicationRoute
  '/$shortCode/submit': typeof ShortCodeSubmitRoute
  '/ad-performance': typeof DashboardAdPerformanceRoute
  '/capi': typeof DashboardCapiRoute
  '/media-mix': typeof DashboardMediaMixRoute
  '/product-groups': typeof DashboardProductGroupsRoute
  '/seeding-campaigns': typeof DashboardSeedingCampaignsRouteWithChildren
  '/taxonomy': typeof DashboardTaxonomyRoute
  '/admin/customers': typeof AdminCustomersRouteWithChildren
  '/admin/diagnostics': typeof AdminDiagnosticsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/mcp': typeof AdminMcpRoute
  '/admin/meta-approvals': typeof AdminMetaApprovalsRoute
  '/admin/naver-requests': typeof AdminNaverRequestsRoute
  '/admin/oauth-approve': typeof AdminOauthApproveRoute
  '/admin/whitelist': typeof AdminWhitelistRoute
  '/apply/callback': typeof ApplyCallbackRoute
  '/apply/privacy': typeof ApplyPrivacyRoute
  '/apply/terms': typeof ApplyTermsRoute
  '/auth/link': typeof AuthLinkRoute
  '/auth/success': typeof AuthSuccessRoute
  '/campus-sso/select': typeof CampusSsoSelectRoute
  '/$shortCode': typeof ShortCodeIndexRoute
  '/': typeof DashboardIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/catalog/$productNo': typeof DashboardCatalogProductNoRoute
  '/seeding-campaigns/$campaignId': typeof DashboardSeedingCampaignsCampaignIdRouteWithChildren
  '/seeding-campaigns/new': typeof DashboardSeedingCampaignsNewRoute
  '/setup/google': typeof DashboardSetupGoogleRoute
  '/setup/kakao': typeof DashboardSetupKakaoRoute
  '/setup/meta-ads': typeof DashboardSetupMetaAdsRoute
  '/setup/meta-capi': typeof DashboardSetupMetaCapiRoute
  '/setup/meta-catalog': typeof DashboardSetupMetaCatalogRoute
  '/setup/mixpanel': typeof DashboardSetupMixpanelRoute
  '/setup/naver': typeof DashboardSetupNaverRoute
  '/setup/script': typeof DashboardSetupScriptRoute
  '/setup/tiktok': typeof DashboardSetupTiktokRoute
  '/admin/customers/$customerId': typeof AdminCustomersCustomerIdRoute
  '/apply/$mallId/$shopNo': typeof ApplyMallIdShopNoRouteWithChildren
  '/catalog': typeof DashboardCatalogIndexRoute
  '/seeding-campaigns/$campaignId/edit': typeof DashboardSeedingCampaignsCampaignIdEditRoute
  '/apply/$mallId/$shopNo/$campaignId': typeof ApplyMallIdShopNoCampaignIdRoute
  '/apply/$mallId/$shopNo/my-application/$campaignId': typeof ApplyMallIdShopNoMyApplicationCampaignIdRoute
  '/apply/$mallId/$shopNo/submit/$campaignId': typeof ApplyMallIdShopNoSubmitCampaignIdRoute
}
export interface FileRoutesByTo {
  '/cafe24-reauth': typeof Cafe24ReauthRoute
  '/install-not-eligible': typeof InstallNotEligibleRoute
  '/no-linked-mall': typeof NoLinkedMallRoute
  '/notice': typeof NoticeRoute
  '/shop-limit-exceeded': typeof ShopLimitExceededRoute
  '/shop-select': typeof ShopSelectRoute
  '/$shortCode/my-application': typeof ShortCodeMyApplicationRoute
  '/$shortCode/submit': typeof ShortCodeSubmitRoute
  '/ad-performance': typeof DashboardAdPerformanceRoute
  '/capi': typeof DashboardCapiRoute
  '/media-mix': typeof DashboardMediaMixRoute
  '/product-groups': typeof DashboardProductGroupsRoute
  '/seeding-campaigns': typeof DashboardSeedingCampaignsRouteWithChildren
  '/taxonomy': typeof DashboardTaxonomyRoute
  '/admin/customers': typeof AdminCustomersRouteWithChildren
  '/admin/diagnostics': typeof AdminDiagnosticsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/mcp': typeof AdminMcpRoute
  '/admin/meta-approvals': typeof AdminMetaApprovalsRoute
  '/admin/naver-requests': typeof AdminNaverRequestsRoute
  '/admin/oauth-approve': typeof AdminOauthApproveRoute
  '/admin/whitelist': typeof AdminWhitelistRoute
  '/apply/callback': typeof ApplyCallbackRoute
  '/apply/privacy': typeof ApplyPrivacyRoute
  '/apply/terms': typeof ApplyTermsRoute
  '/auth/link': typeof AuthLinkRoute
  '/auth/success': typeof AuthSuccessRoute
  '/campus-sso/select': typeof CampusSsoSelectRoute
  '/$shortCode': typeof ShortCodeIndexRoute
  '/': typeof DashboardIndexRoute
  '/admin': typeof AdminIndexRoute
  '/catalog/$productNo': typeof DashboardCatalogProductNoRoute
  '/seeding-campaigns/$campaignId': typeof DashboardSeedingCampaignsCampaignIdRouteWithChildren
  '/seeding-campaigns/new': typeof DashboardSeedingCampaignsNewRoute
  '/setup/google': typeof DashboardSetupGoogleRoute
  '/setup/kakao': typeof DashboardSetupKakaoRoute
  '/setup/meta-ads': typeof DashboardSetupMetaAdsRoute
  '/setup/meta-capi': typeof DashboardSetupMetaCapiRoute
  '/setup/meta-catalog': typeof DashboardSetupMetaCatalogRoute
  '/setup/mixpanel': typeof DashboardSetupMixpanelRoute
  '/setup/naver': typeof DashboardSetupNaverRoute
  '/setup/script': typeof DashboardSetupScriptRoute
  '/setup/tiktok': typeof DashboardSetupTiktokRoute
  '/admin/customers/$customerId': typeof AdminCustomersCustomerIdRoute
  '/apply/$mallId/$shopNo': typeof ApplyMallIdShopNoRouteWithChildren
  '/catalog': typeof DashboardCatalogIndexRoute
  '/seeding-campaigns/$campaignId/edit': typeof DashboardSeedingCampaignsCampaignIdEditRoute
  '/apply/$mallId/$shopNo/$campaignId': typeof ApplyMallIdShopNoCampaignIdRoute
  '/apply/$mallId/$shopNo/my-application/$campaignId': typeof ApplyMallIdShopNoMyApplicationCampaignIdRoute
  '/apply/$mallId/$shopNo/submit/$campaignId': typeof ApplyMallIdShopNoSubmitCampaignIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/cafe24-reauth': typeof Cafe24ReauthRoute
  '/install-not-eligible': typeof InstallNotEligibleRoute
  '/no-linked-mall': typeof NoLinkedMallRoute
  '/notice': typeof NoticeRoute
  '/shop-limit-exceeded': typeof ShopLimitExceededRoute
  '/shop-select': typeof ShopSelectRoute
  '/$shortCode/my-application': typeof ShortCodeMyApplicationRoute
  '/$shortCode/submit': typeof ShortCodeSubmitRoute
  '/_dashboard/ad-performance': typeof DashboardAdPerformanceRoute
  '/_dashboard/capi': typeof DashboardCapiRoute
  '/_dashboard/media-mix': typeof DashboardMediaMixRoute
  '/_dashboard/product-groups': typeof DashboardProductGroupsRoute
  '/_dashboard/seeding-campaigns': typeof DashboardSeedingCampaignsRouteWithChildren
  '/_dashboard/taxonomy': typeof DashboardTaxonomyRoute
  '/admin/customers': typeof AdminCustomersRouteWithChildren
  '/admin/diagnostics': typeof AdminDiagnosticsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/mcp': typeof AdminMcpRoute
  '/admin/meta-approvals': typeof AdminMetaApprovalsRoute
  '/admin/naver-requests': typeof AdminNaverRequestsRoute
  '/admin/oauth-approve': typeof AdminOauthApproveRoute
  '/admin/whitelist': typeof AdminWhitelistRoute
  '/apply/callback': typeof ApplyCallbackRoute
  '/apply/privacy': typeof ApplyPrivacyRoute
  '/apply/terms': typeof ApplyTermsRoute
  '/auth/link': typeof AuthLinkRoute
  '/auth/success': typeof AuthSuccessRoute
  '/campus-sso/select': typeof CampusSsoSelectRoute
  '/$shortCode/': typeof ShortCodeIndexRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/_dashboard/catalog/$productNo': typeof DashboardCatalogProductNoRoute
  '/_dashboard/seeding-campaigns/$campaignId': typeof DashboardSeedingCampaignsCampaignIdRouteWithChildren
  '/_dashboard/seeding-campaigns/new': typeof DashboardSeedingCampaignsNewRoute
  '/_dashboard/setup/google': typeof DashboardSetupGoogleRoute
  '/_dashboard/setup/kakao': typeof DashboardSetupKakaoRoute
  '/_dashboard/setup/meta-ads': typeof DashboardSetupMetaAdsRoute
  '/_dashboard/setup/meta-capi': typeof DashboardSetupMetaCapiRoute
  '/_dashboard/setup/meta-catalog': typeof DashboardSetupMetaCatalogRoute
  '/_dashboard/setup/mixpanel': typeof DashboardSetupMixpanelRoute
  '/_dashboard/setup/naver': typeof DashboardSetupNaverRoute
  '/_dashboard/setup/script': typeof DashboardSetupScriptRoute
  '/_dashboard/setup/tiktok': typeof DashboardSetupTiktokRoute
  '/admin/customers/$customerId': typeof AdminCustomersCustomerIdRoute
  '/apply/$mallId/$shopNo': typeof ApplyMallIdShopNoRouteWithChildren
  '/_dashboard/catalog/': typeof DashboardCatalogIndexRoute
  '/_dashboard/seeding-campaigns/$campaignId/edit': typeof DashboardSeedingCampaignsCampaignIdEditRoute
  '/apply/$mallId/$shopNo/$campaignId': typeof ApplyMallIdShopNoCampaignIdRoute
  '/apply/$mallId/$shopNo/my-application/$campaignId': typeof ApplyMallIdShopNoMyApplicationCampaignIdRoute
  '/apply/$mallId/$shopNo/submit/$campaignId': typeof ApplyMallIdShopNoSubmitCampaignIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin'
    | '/cafe24-reauth'
    | '/install-not-eligible'
    | '/no-linked-mall'
    | '/notice'
    | '/shop-limit-exceeded'
    | '/shop-select'
    | '/$shortCode/my-application'
    | '/$shortCode/submit'
    | '/ad-performance'
    | '/capi'
    | '/media-mix'
    | '/product-groups'
    | '/seeding-campaigns'
    | '/taxonomy'
    | '/admin/customers'
    | '/admin/diagnostics'
    | '/admin/login'
    | '/admin/mcp'
    | '/admin/meta-approvals'
    | '/admin/naver-requests'
    | '/admin/oauth-approve'
    | '/admin/whitelist'
    | '/apply/callback'
    | '/apply/privacy'
    | '/apply/terms'
    | '/auth/link'
    | '/auth/success'
    | '/campus-sso/select'
    | '/$shortCode'
    | '/'
    | '/admin/'
    | '/catalog/$productNo'
    | '/seeding-campaigns/$campaignId'
    | '/seeding-campaigns/new'
    | '/setup/google'
    | '/setup/kakao'
    | '/setup/meta-ads'
    | '/setup/meta-capi'
    | '/setup/meta-catalog'
    | '/setup/mixpanel'
    | '/setup/naver'
    | '/setup/script'
    | '/setup/tiktok'
    | '/admin/customers/$customerId'
    | '/apply/$mallId/$shopNo'
    | '/catalog'
    | '/seeding-campaigns/$campaignId/edit'
    | '/apply/$mallId/$shopNo/$campaignId'
    | '/apply/$mallId/$shopNo/my-application/$campaignId'
    | '/apply/$mallId/$shopNo/submit/$campaignId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/cafe24-reauth'
    | '/install-not-eligible'
    | '/no-linked-mall'
    | '/notice'
    | '/shop-limit-exceeded'
    | '/shop-select'
    | '/$shortCode/my-application'
    | '/$shortCode/submit'
    | '/ad-performance'
    | '/capi'
    | '/media-mix'
    | '/product-groups'
    | '/seeding-campaigns'
    | '/taxonomy'
    | '/admin/customers'
    | '/admin/diagnostics'
    | '/admin/login'
    | '/admin/mcp'
    | '/admin/meta-approvals'
    | '/admin/naver-requests'
    | '/admin/oauth-approve'
    | '/admin/whitelist'
    | '/apply/callback'
    | '/apply/privacy'
    | '/apply/terms'
    | '/auth/link'
    | '/auth/success'
    | '/campus-sso/select'
    | '/$shortCode'
    | '/'
    | '/admin'
    | '/catalog/$productNo'
    | '/seeding-campaigns/$campaignId'
    | '/seeding-campaigns/new'
    | '/setup/google'
    | '/setup/kakao'
    | '/setup/meta-ads'
    | '/setup/meta-capi'
    | '/setup/meta-catalog'
    | '/setup/mixpanel'
    | '/setup/naver'
    | '/setup/script'
    | '/setup/tiktok'
    | '/admin/customers/$customerId'
    | '/apply/$mallId/$shopNo'
    | '/catalog'
    | '/seeding-campaigns/$campaignId/edit'
    | '/apply/$mallId/$shopNo/$campaignId'
    | '/apply/$mallId/$shopNo/my-application/$campaignId'
    | '/apply/$mallId/$shopNo/submit/$campaignId'
  id:
    | '__root__'
    | '/_dashboard'
    | '/admin'
    | '/cafe24-reauth'
    | '/install-not-eligible'
    | '/no-linked-mall'
    | '/notice'
    | '/shop-limit-exceeded'
    | '/shop-select'
    | '/$shortCode/my-application'
    | '/$shortCode/submit'
    | '/_dashboard/ad-performance'
    | '/_dashboard/capi'
    | '/_dashboard/media-mix'
    | '/_dashboard/product-groups'
    | '/_dashboard/seeding-campaigns'
    | '/_dashboard/taxonomy'
    | '/admin/customers'
    | '/admin/diagnostics'
    | '/admin/login'
    | '/admin/mcp'
    | '/admin/meta-approvals'
    | '/admin/naver-requests'
    | '/admin/oauth-approve'
    | '/admin/whitelist'
    | '/apply/callback'
    | '/apply/privacy'
    | '/apply/terms'
    | '/auth/link'
    | '/auth/success'
    | '/campus-sso/select'
    | '/$shortCode/'
    | '/_dashboard/'
    | '/admin/'
    | '/_dashboard/catalog/$productNo'
    | '/_dashboard/seeding-campaigns/$campaignId'
    | '/_dashboard/seeding-campaigns/new'
    | '/_dashboard/setup/google'
    | '/_dashboard/setup/kakao'
    | '/_dashboard/setup/meta-ads'
    | '/_dashboard/setup/meta-capi'
    | '/_dashboard/setup/meta-catalog'
    | '/_dashboard/setup/mixpanel'
    | '/_dashboard/setup/naver'
    | '/_dashboard/setup/script'
    | '/_dashboard/setup/tiktok'
    | '/admin/customers/$customerId'
    | '/apply/$mallId/$shopNo'
    | '/_dashboard/catalog/'
    | '/_dashboard/seeding-campaigns/$campaignId/edit'
    | '/apply/$mallId/$shopNo/$campaignId'
    | '/apply/$mallId/$shopNo/my-application/$campaignId'
    | '/apply/$mallId/$shopNo/submit/$campaignId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  Cafe24ReauthRoute: typeof Cafe24ReauthRoute
  InstallNotEligibleRoute: typeof InstallNotEligibleRoute
  NoLinkedMallRoute: typeof NoLinkedMallRoute
  NoticeRoute: typeof NoticeRoute
  ShopLimitExceededRoute: typeof ShopLimitExceededRoute
  ShopSelectRoute: typeof ShopSelectRoute
  ShortCodeMyApplicationRoute: typeof ShortCodeMyApplicationRoute
  ShortCodeSubmitRoute: typeof ShortCodeSubmitRoute
  ApplyCallbackRoute: typeof ApplyCallbackRoute
  ApplyPrivacyRoute: typeof ApplyPrivacyRoute
  ApplyTermsRoute: typeof ApplyTermsRoute
  AuthLinkRoute: typeof AuthLinkRoute
  AuthSuccessRoute: typeof AuthSuccessRoute
  CampusSsoSelectRoute: typeof CampusSsoSelectRoute
  ShortCodeIndexRoute: typeof ShortCodeIndexRoute
  ApplyMallIdShopNoRoute: typeof ApplyMallIdShopNoRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/shop-select': {
      id: '/shop-select'
      path: '/shop-select'
      fullPath: '/shop-select'
      preLoaderRoute: typeof ShopSelectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shop-limit-exceeded': {
      id: '/shop-limit-exceeded'
      path: '/shop-limit-exceeded'
      fullPath: '/shop-limit-exceeded'
      preLoaderRoute: typeof ShopLimitExceededRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notice': {
      id: '/notice'
      path: '/notice'
      fullPath: '/notice'
      preLoaderRoute: typeof NoticeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-linked-mall': {
      id: '/no-linked-mall'
      path: '/no-linked-mall'
      fullPath: '/no-linked-mall'
      preLoaderRoute: typeof NoLinkedMallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/install-not-eligible': {
      id: '/install-not-eligible'
      path: '/install-not-eligible'
      fullPath: '/install-not-eligible'
      preLoaderRoute: typeof InstallNotEligibleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cafe24-reauth': {
      id: '/cafe24-reauth'
      path: '/cafe24-reauth'
      fullPath: '/cafe24-reauth'
      preLoaderRoute: typeof Cafe24ReauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/$shortCode/': {
      id: '/$shortCode/'
      path: '/$shortCode'
      fullPath: '/$shortCode'
      preLoaderRoute: typeof ShortCodeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campus-sso/select': {
      id: '/campus-sso/select'
      path: '/campus-sso/select'
      fullPath: '/campus-sso/select'
      preLoaderRoute: typeof CampusSsoSelectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/success': {
      id: '/auth/success'
      path: '/auth/success'
      fullPath: '/auth/success'
      preLoaderRoute: typeof AuthSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/link': {
      id: '/auth/link'
      path: '/auth/link'
      fullPath: '/auth/link'
      preLoaderRoute: typeof AuthLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply/terms': {
      id: '/apply/terms'
      path: '/apply/terms'
      fullPath: '/apply/terms'
      preLoaderRoute: typeof ApplyTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply/privacy': {
      id: '/apply/privacy'
      path: '/apply/privacy'
      fullPath: '/apply/privacy'
      preLoaderRoute: typeof ApplyPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply/callback': {
      id: '/apply/callback'
      path: '/apply/callback'
      fullPath: '/apply/callback'
      preLoaderRoute: typeof ApplyCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/whitelist': {
      id: '/admin/whitelist'
      path: '/whitelist'
      fullPath: '/admin/whitelist'
      preLoaderRoute: typeof AdminWhitelistRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/oauth-approve': {
      id: '/admin/oauth-approve'
      path: '/oauth-approve'
      fullPath: '/admin/oauth-approve'
      preLoaderRoute: typeof AdminOauthApproveRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/naver-requests': {
      id: '/admin/naver-requests'
      path: '/naver-requests'
      fullPath: '/admin/naver-requests'
      preLoaderRoute: typeof AdminNaverRequestsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/meta-approvals': {
      id: '/admin/meta-approvals'
      path: '/meta-approvals'
      fullPath: '/admin/meta-approvals'
      preLoaderRoute: typeof AdminMetaApprovalsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/mcp': {
      id: '/admin/mcp'
      path: '/mcp'
      fullPath: '/admin/mcp'
      preLoaderRoute: typeof AdminMcpRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/diagnostics': {
      id: '/admin/diagnostics'
      path: '/diagnostics'
      fullPath: '/admin/diagnostics'
      preLoaderRoute: typeof AdminDiagnosticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers': {
      id: '/admin/customers'
      path: '/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_dashboard/taxonomy': {
      id: '/_dashboard/taxonomy'
      path: '/taxonomy'
      fullPath: '/taxonomy'
      preLoaderRoute: typeof DashboardTaxonomyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/seeding-campaigns': {
      id: '/_dashboard/seeding-campaigns'
      path: '/seeding-campaigns'
      fullPath: '/seeding-campaigns'
      preLoaderRoute: typeof DashboardSeedingCampaignsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/product-groups': {
      id: '/_dashboard/product-groups'
      path: '/product-groups'
      fullPath: '/product-groups'
      preLoaderRoute: typeof DashboardProductGroupsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/media-mix': {
      id: '/_dashboard/media-mix'
      path: '/media-mix'
      fullPath: '/media-mix'
      preLoaderRoute: typeof DashboardMediaMixRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/capi': {
      id: '/_dashboard/capi'
      path: '/capi'
      fullPath: '/capi'
      preLoaderRoute: typeof DashboardCapiRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/ad-performance': {
      id: '/_dashboard/ad-performance'
      path: '/ad-performance'
      fullPath: '/ad-performance'
      preLoaderRoute: typeof DashboardAdPerformanceRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/$shortCode/submit': {
      id: '/$shortCode/submit'
      path: '/$shortCode/submit'
      fullPath: '/$shortCode/submit'
      preLoaderRoute: typeof ShortCodeSubmitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$shortCode/my-application': {
      id: '/$shortCode/my-application'
      path: '/$shortCode/my-application'
      fullPath: '/$shortCode/my-application'
      preLoaderRoute: typeof ShortCodeMyApplicationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/catalog/': {
      id: '/_dashboard/catalog/'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof DashboardCatalogIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/apply/$mallId/$shopNo': {
      id: '/apply/$mallId/$shopNo'
      path: '/apply/$mallId/$shopNo'
      fullPath: '/apply/$mallId/$shopNo'
      preLoaderRoute: typeof ApplyMallIdShopNoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/customers/$customerId': {
      id: '/admin/customers/$customerId'
      path: '/$customerId'
      fullPath: '/admin/customers/$customerId'
      preLoaderRoute: typeof AdminCustomersCustomerIdRouteImport
      parentRoute: typeof AdminCustomersRoute
    }
    '/_dashboard/setup/tiktok': {
      id: '/_dashboard/setup/tiktok'
      path: '/setup/tiktok'
      fullPath: '/setup/tiktok'
      preLoaderRoute: typeof DashboardSetupTiktokRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/setup/script': {
      id: '/_dashboard/setup/script'
      path: '/setup/script'
      fullPath: '/setup/script'
      preLoaderRoute: typeof DashboardSetupScriptRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/setup/naver': {
      id: '/_dashboard/setup/naver'
      path: '/setup/naver'
      fullPath: '/setup/naver'
      preLoaderRoute: typeof DashboardSetupNaverRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/setup/mixpanel': {
      id: '/_dashboard/setup/mixpanel'
      path: '/setup/mixpanel'
      fullPath: '/setup/mixpanel'
      preLoaderRoute: typeof DashboardSetupMixpanelRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/setup/meta-catalog': {
      id: '/_dashboard/setup/meta-catalog'
      path: '/setup/meta-catalog'
      fullPath: '/setup/meta-catalog'
      preLoaderRoute: typeof DashboardSetupMetaCatalogRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/setup/meta-capi': {
      id: '/_dashboard/setup/meta-capi'
      path: '/setup/meta-capi'
      fullPath: '/setup/meta-capi'
      preLoaderRoute: typeof DashboardSetupMetaCapiRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/setup/meta-ads': {
      id: '/_dashboard/setup/meta-ads'
      path: '/setup/meta-ads'
      fullPath: '/setup/meta-ads'
      preLoaderRoute: typeof DashboardSetupMetaAdsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/setup/kakao': {
      id: '/_dashboard/setup/kakao'
      path: '/setup/kakao'
      fullPath: '/setup/kakao'
      preLoaderRoute: typeof DashboardSetupKakaoRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/setup/google': {
      id: '/_dashboard/setup/google'
      path: '/setup/google'
      fullPath: '/setup/google'
      preLoaderRoute: typeof DashboardSetupGoogleRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/seeding-campaigns/new': {
      id: '/_dashboard/seeding-campaigns/new'
      path: '/new'
      fullPath: '/seeding-campaigns/new'
      preLoaderRoute: typeof DashboardSeedingCampaignsNewRouteImport
      parentRoute: typeof DashboardSeedingCampaignsRoute
    }
    '/_dashboard/seeding-campaigns/$campaignId': {
      id: '/_dashboard/seeding-campaigns/$campaignId'
      path: '/$campaignId'
      fullPath: '/seeding-campaigns/$campaignId'
      preLoaderRoute: typeof DashboardSeedingCampaignsCampaignIdRouteImport
      parentRoute: typeof DashboardSeedingCampaignsRoute
    }
    '/_dashboard/catalog/$productNo': {
      id: '/_dashboard/catalog/$productNo'
      path: '/catalog/$productNo'
      fullPath: '/catalog/$productNo'
      preLoaderRoute: typeof DashboardCatalogProductNoRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/apply/$mallId/$shopNo/$campaignId': {
      id: '/apply/$mallId/$shopNo/$campaignId'
      path: '/$campaignId'
      fullPath: '/apply/$mallId/$shopNo/$campaignId'
      preLoaderRoute: typeof ApplyMallIdShopNoCampaignIdRouteImport
      parentRoute: typeof ApplyMallIdShopNoRoute
    }
    '/_dashboard/seeding-campaigns/$campaignId/edit': {
      id: '/_dashboard/seeding-campaigns/$campaignId/edit'
      path: '/edit'
      fullPath: '/seeding-campaigns/$campaignId/edit'
      preLoaderRoute: typeof DashboardSeedingCampaignsCampaignIdEditRouteImport
      parentRoute: typeof DashboardSeedingCampaignsCampaignIdRoute
    }
    '/apply/$mallId/$shopNo/submit/$campaignId': {
      id: '/apply/$mallId/$shopNo/submit/$campaignId'
      path: '/submit/$campaignId'
      fullPath: '/apply/$mallId/$shopNo/submit/$campaignId'
      preLoaderRoute: typeof ApplyMallIdShopNoSubmitCampaignIdRouteImport
      parentRoute: typeof ApplyMallIdShopNoRoute
    }
    '/apply/$mallId/$shopNo/my-application/$campaignId': {
      id: '/apply/$mallId/$shopNo/my-application/$campaignId'
      path: '/my-application/$campaignId'
      fullPath: '/apply/$mallId/$shopNo/my-application/$campaignId'
      preLoaderRoute: typeof ApplyMallIdShopNoMyApplicationCampaignIdRouteImport
      parentRoute: typeof ApplyMallIdShopNoRoute
    }
  }
}

interface DashboardSeedingCampaignsCampaignIdRouteChildren {
  DashboardSeedingCampaignsCampaignIdEditRoute: typeof DashboardSeedingCampaignsCampaignIdEditRoute
}

const DashboardSeedingCampaignsCampaignIdRouteChildren: DashboardSeedingCampaignsCampaignIdRouteChildren =
  {
    DashboardSeedingCampaignsCampaignIdEditRoute:
      DashboardSeedingCampaignsCampaignIdEditRoute,
  }

const DashboardSeedingCampaignsCampaignIdRouteWithChildren =
  DashboardSeedingCampaignsCampaignIdRoute._addFileChildren(
    DashboardSeedingCampaignsCampaignIdRouteChildren,
  )

interface DashboardSeedingCampaignsRouteChildren {
  DashboardSeedingCampaignsCampaignIdRoute: typeof DashboardSeedingCampaignsCampaignIdRouteWithChildren
  DashboardSeedingCampaignsNewRoute: typeof DashboardSeedingCampaignsNewRoute
}

const DashboardSeedingCampaignsRouteChildren: DashboardSeedingCampaignsRouteChildren =
  {
    DashboardSeedingCampaignsCampaignIdRoute:
      DashboardSeedingCampaignsCampaignIdRouteWithChildren,
    DashboardSeedingCampaignsNewRoute: DashboardSeedingCampaignsNewRoute,
  }

const DashboardSeedingCampaignsRouteWithChildren =
  DashboardSeedingCampaignsRoute._addFileChildren(
    DashboardSeedingCampaignsRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardAdPerformanceRoute: typeof DashboardAdPerformanceRoute
  DashboardCapiRoute: typeof DashboardCapiRoute
  DashboardMediaMixRoute: typeof DashboardMediaMixRoute
  DashboardProductGroupsRoute: typeof DashboardProductGroupsRoute
  DashboardSeedingCampaignsRoute: typeof DashboardSeedingCampaignsRouteWithChildren
  DashboardTaxonomyRoute: typeof DashboardTaxonomyRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardCatalogProductNoRoute: typeof DashboardCatalogProductNoRoute
  DashboardSetupGoogleRoute: typeof DashboardSetupGoogleRoute
  DashboardSetupKakaoRoute: typeof DashboardSetupKakaoRoute
  DashboardSetupMetaAdsRoute: typeof DashboardSetupMetaAdsRoute
  DashboardSetupMetaCapiRoute: typeof DashboardSetupMetaCapiRoute
  DashboardSetupMetaCatalogRoute: typeof DashboardSetupMetaCatalogRoute
  DashboardSetupMixpanelRoute: typeof DashboardSetupMixpanelRoute
  DashboardSetupNaverRoute: typeof DashboardSetupNaverRoute
  DashboardSetupScriptRoute: typeof DashboardSetupScriptRoute
  DashboardSetupTiktokRoute: typeof DashboardSetupTiktokRoute
  DashboardCatalogIndexRoute: typeof DashboardCatalogIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAdPerformanceRoute: DashboardAdPerformanceRoute,
  DashboardCapiRoute: DashboardCapiRoute,
  DashboardMediaMixRoute: DashboardMediaMixRoute,
  DashboardProductGroupsRoute: DashboardProductGroupsRoute,
  DashboardSeedingCampaignsRoute: DashboardSeedingCampaignsRouteWithChildren,
  DashboardTaxonomyRoute: DashboardTaxonomyRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardCatalogProductNoRoute: DashboardCatalogProductNoRoute,
  DashboardSetupGoogleRoute: DashboardSetupGoogleRoute,
  DashboardSetupKakaoRoute: DashboardSetupKakaoRoute,
  DashboardSetupMetaAdsRoute: DashboardSetupMetaAdsRoute,
  DashboardSetupMetaCapiRoute: DashboardSetupMetaCapiRoute,
  DashboardSetupMetaCatalogRoute: DashboardSetupMetaCatalogRoute,
  DashboardSetupMixpanelRoute: DashboardSetupMixpanelRoute,
  DashboardSetupNaverRoute: DashboardSetupNaverRoute,
  DashboardSetupScriptRoute: DashboardSetupScriptRoute,
  DashboardSetupTiktokRoute: DashboardSetupTiktokRoute,
  DashboardCatalogIndexRoute: DashboardCatalogIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface AdminCustomersRouteChildren {
  AdminCustomersCustomerIdRoute: typeof AdminCustomersCustomerIdRoute
}

const AdminCustomersRouteChildren: AdminCustomersRouteChildren = {
  AdminCustomersCustomerIdRoute: AdminCustomersCustomerIdRoute,
}

const AdminCustomersRouteWithChildren = AdminCustomersRoute._addFileChildren(
  AdminCustomersRouteChildren,
)

interface AdminRouteChildren {
  AdminCustomersRoute: typeof AdminCustomersRouteWithChildren
  AdminDiagnosticsRoute: typeof AdminDiagnosticsRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminMcpRoute: typeof AdminMcpRoute
  AdminMetaApprovalsRoute: typeof AdminMetaApprovalsRoute
  AdminNaverRequestsRoute: typeof AdminNaverRequestsRoute
  AdminOauthApproveRoute: typeof AdminOauthApproveRoute
  AdminWhitelistRoute: typeof AdminWhitelistRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCustomersRoute: AdminCustomersRouteWithChildren,
  AdminDiagnosticsRoute: AdminDiagnosticsRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminMcpRoute: AdminMcpRoute,
  AdminMetaApprovalsRoute: AdminMetaApprovalsRoute,
  AdminNaverRequestsRoute: AdminNaverRequestsRoute,
  AdminOauthApproveRoute: AdminOauthApproveRoute,
  AdminWhitelistRoute: AdminWhitelistRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ApplyMallIdShopNoRouteChildren {
  ApplyMallIdShopNoCampaignIdRoute: typeof ApplyMallIdShopNoCampaignIdRoute
  ApplyMallIdShopNoMyApplicationCampaignIdRoute: typeof ApplyMallIdShopNoMyApplicationCampaignIdRoute
  ApplyMallIdShopNoSubmitCampaignIdRoute: typeof ApplyMallIdShopNoSubmitCampaignIdRoute
}

const ApplyMallIdShopNoRouteChildren: ApplyMallIdShopNoRouteChildren = {
  ApplyMallIdShopNoCampaignIdRoute: ApplyMallIdShopNoCampaignIdRoute,
  ApplyMallIdShopNoMyApplicationCampaignIdRoute:
    ApplyMallIdShopNoMyApplicationCampaignIdRoute,
  ApplyMallIdShopNoSubmitCampaignIdRoute:
    ApplyMallIdShopNoSubmitCampaignIdRoute,
}

const ApplyMallIdShopNoRouteWithChildren =
  ApplyMallIdShopNoRoute._addFileChildren(ApplyMallIdShopNoRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  Cafe24ReauthRoute: Cafe24ReauthRoute,
  InstallNotEligibleRoute: InstallNotEligibleRoute,
  NoLinkedMallRoute: NoLinkedMallRoute,
  NoticeRoute: NoticeRoute,
  ShopLimitExceededRoute: ShopLimitExceededRoute,
  ShopSelectRoute: ShopSelectRoute,
  ShortCodeMyApplicationRoute: ShortCodeMyApplicationRoute,
  ShortCodeSubmitRoute: ShortCodeSubmitRoute,
  ApplyCallbackRoute: ApplyCallbackRoute,
  ApplyPrivacyRoute: ApplyPrivacyRoute,
  ApplyTermsRoute: ApplyTermsRoute,
  AuthLinkRoute: AuthLinkRoute,
  AuthSuccessRoute: AuthSuccessRoute,
  CampusSsoSelectRoute: CampusSsoSelectRoute,
  ShortCodeIndexRoute: ShortCodeIndexRoute,
  ApplyMallIdShopNoRoute: ApplyMallIdShopNoRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
